import React, { memo } from 'react'
import tw from 'twin.macro'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { InsurancePolicyFormValues } from './InsurancePolicyForm.interface'

const InsurancePolicyFormContentComponent = () => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<InsurancePolicyFormValues>
        name="name"
        label="Name"
        placeholder="e.g. Standard Driver Coverage"
      />
    </div>
  )
}

export const InsurancePolicyFormContent = memo(InsurancePolicyFormContentComponent)
